<template>
  <div>
    <base-list-management ref="baseListManagement" :configData.sync="configData">
      <template slot="custom-export">
        <el-button
          v-if="hasExportPermission"
          :loading="exportLoading"
          @click="asyncExportHandle"
          >
          导出数据
        </el-button>
        <el-button
          v-if="hasExportPermission"
          @click="exportDataHandle"
          >
          导出列表
        </el-button>
      </template>
    </base-list-management>
    <violationDetail :source="detailSource" ref="violationDetailRef"></violationDetail>
    <!-- 导出列表 -->
    <exportListDialog
      v-if="exportListVisible"
      :dialogVisible="exportListVisible"
      :taskType="7"
      filename="违章记录列表"
      @close="exportListVisible = false"
    />
  </div>
</template>
<script>
import config from './config'
import violationDetail from '@/pages/service/Violation/components/violationDetail.vue'
import { getViolationDetail, ViolationDetail, exportViolationDetail } from '@/api/domain/carsService'
import { CUSTOMER_TYPE } from '../../config'
import exportListDialog from '@/pages/orders/overdue/components/exportListDialog.vue'
import * as Sentry from '@sentry/vue'

const API_CONF = {
  [CUSTOMER_TYPE.PERSON]: getViolationDetail,
  [CUSTOMER_TYPE.ENTERPRISE]: ViolationDetail,
}

export default {
  name: 'order',
  components: { violationDetail, exportListDialog },
  // eslint-disable-next-line vue/no-unused-properties
  props: ['customerId', 'customerType'],
  data() {
    const configData = config.call(this)
    configData.tableData.apiFn = API_CONF[this.customerType]
    return {
      configData,
      detailSource: {},
      exportLoading: false,
      exportListVisible: false,
    }
  },
  computed: {
    hasExportPermission() {
      return this.judgePermission('vehicle_violation_record_list_export')
    },
  },
  mounted() {
    this.configData.tableData.columns.push(this.configData.operateColumn)
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    detail(data) {
      this.detailSource = { ...data }
      this.$refs.violationDetailRef.isShow = true
    },
    // 异步导出数据
    asyncExportHandle() {
      this.exportLoading = true
      const params = this.$refs.baseListManagement.getParams()
      exportViolationDetail(params).then(({ code }) => {
        if (code === 1) {
          this.$message.success('所选数据已生成下载文件，请点击【导出列表】查看下载')
        }
      }).catch((e) => {
        Sentry.captureException(e)
      }).finally(() => {
        this.exportLoading = false
      })
    },
    // 导出列表
    exportDataHandle() {
      this.exportListVisible = true
    },
  },
}
</script>
